import HttpHelper from './helper';


export const serviceIdEndpoints = {
    get: (params) => HttpHelper.baseAxios
        .get('/getService', { params })
        .then((res) => res?.data)
        .catch((err) => err?.response?.data),
};
